import request from './utils/request'

export function login(username: string, password: string) {
    return request.post('/login', {
        username,
        password,
    })
}

export function refreshToken() {
    return request.post('/refresh')
}

export function getContractFile(contractId: number) {
    return request.get(`/contract/file/${contractId}`, {
        responseType: 'blob',
    })
}

export function getContractInfo(contractId: number) {
    return request.get(`/contract/info/${contractId}`)
}

export function uploadContract(data: FormData) {
    return request.post('/contract/upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data;charset=utf-8',
        },
        timeout: 300000,
    })
}

export function queryUploadContracts(currentPage: number, pageSize: number, data?: any) {
    data = data ? data : {}
    return request.post('/contract/list/upload', { ...data, currentPage, pageSize }, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export function queryApproveContracts(currentPage: number, pageSize: number, data?: any) {
    data = data ? data : {}
    return request.post('/contract/list/approve', { ...data, currentPage, pageSize }, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export function deleteContract(contractId: number) {
    return request.get(`/contract/delete/${contractId}`)
}

export function submitContract(data: any) {
    return request.post('/contract/submit', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export function getApproverList() {
    return request.get('/contract/approvers')
}

export function approveContract(contract_id: number, passed: number, comment?: string) {
    const data: any = {
        contract_id,
        passed,
    }
    if (comment) {
        data.comment = comment
    }
    return request.post('/contract/approve', data)
}

export function searchContract(formData?: any) {
    if (!formData) {
        formData = {}
    }
    return request.post('/search', formData, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export function searchContractByIds(ids: number[]) {
    return request.post('/search_by_ids', { ids }, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export function searchSugEntities(content: string) {
    return request.post('/graph/suggest_entities', { content }, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export function searchEntities(id: number, groupIds = []) {
    const params = {
        id,
    }
    if (groupIds && groupIds.length > 0) {
        params['groupIds'] = groupIds
    }
    return request.post('/graph/search_entities', params, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export function searchNeighbours(id: number, isHKEX = false, groupIds = []) {
    const params = {
        id,
        isHKEX,
    }
    if (groupIds && groupIds.length > 0) {
        params['groupIds'] = groupIds
    }
    return request.post('/graph/search_neighbours', params, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export function searchHKEX() {
    return request.get('/graph/query_hkex')
}

export function queryHistoryList(id: number) {
    return request.get(`/contract/history/${id}`)
}
